import 'babel-polyfill'

import App from './App'
import router from './router/index'
import {
  HttpService
} from '../services/httpService'
import Status from './status'
import {
  PlatformService
} from '../services/platformService'
import {
  dateToStr
} from './filterFunction/data'
import slefMessage from './messgae/message'

import echarts from 'echarts'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n'
import Vuex from 'Vuex';


Vue.use(VueI18n)
Vue.use(ElementUI)

Vue.prototype.$echarts = echarts

Vue.use(Vuex)

Vue.prototype.$store = new Vuex.Store(Status)
Vue.prototype.$platformService = new PlatformService()
Vue.prototype.$httpService = HttpService
Vue.prototype.$pageDerty = false

// 阻止启动生产消息，常用作指令
Vue.config.productionTip = false

Vue.prototype.$message = slefMessage
Vue.filter('dateToStr', dateToStr)


let agentMap = new Map()
agentMap.set('kefu.xiaolaba.xin', {
  // agentMap.set('localhost:8080', {
  logo: '',
  headerLogo: require('./assets/agent/saier-logo.png'),
  name: '高校智能学习助手',
  loginMsg0: '帮您自动准确解答95%的问题，剩下5%疑问人工回答！',
  loginMsg1: '应用了人工智能的自然语言识别处理、大数据、云计算等技术，',
  loginMsg2: '为学校授课老师建立智能的知识收集、归类、自动解答平台',
  loginMsg3: '产品负责人： 周老师 18310505996（手机、微信）',
  title: '赛尔超星 高校智能客服',
  homePage: 'http://www.xiaolaba.xin/',
  canRegister: false,
  callUs: {
    pic: require('./assets/agent/Wechat.jpeg'),
    code0: '微信扫码关注高校智能客服周老师',
    code1: '功能使用与技能支持: 18310505996',
    email: 'zhour@cernet.com',
  },
  email: 'zhour@cernet.com',
  phone: '18310505996',
  businessDialogMsg: '了解更多功能细节或购买高校智能客服产品，请您联系：',
  nav2Name: '人工客服',
  menu: {
    kbStatistics: '机器人问答统计',
    evaluation: '人工客服问答统计'
  },
  taskName: '第三方应用对接',
  hiddenAccountInfo: true,
  hiddenRobotAdd: true,
  rule: {
    title: '知识文档',
    title1: '文档',
    title2: '通用问答包',
    noData: '文档',
    name: '文档',
  },
  unionId: 95
})


agentMap.set('kefu.ceredu.org', {
  logo: '',
  headerLogo: require('./assets/agent/saier-logo.png'),
  name: '高校智能学习助手',
  loginMsg0: '帮您自动准确解答95%的问题，剩下5%疑问人工回答！',
  loginMsg1: '应用了人工智能的自然语言识别处理、大数据、云计算等技术，',
  loginMsg2: '为学校授课老师建立智能的知识收集、归类、自动解答平台',
  loginMsg3: '产品负责人： 周老师 18310505996（手机、微信）',
  title: '赛尔超星 高校智能客服',
  homePage: 'http://kefu.ceredu.org/',
  canRegister: false,
  callUs: {
    pic: require('./assets/agent/Wechat.jpeg'),
    code0: '微信扫码关注高校智能客服周老师',
    code1: '功能使用与技能支持: 18310505996',
    email: 'zhour@cernet.com',
  },
  email: 'zhour@cernet.com',
  phone: '18310505996',
  businessDialogMsg: '了解更多功能细节或购买高校智能客服产品，请您联系：',
  nav2Name: '人工客服',
  menu: {
    kbStatistics: '机器人问答统计',
    evaluation: '人工客服问答统计'
  },
  taskName: '第三方应用对接',
  hiddenAccountInfo: true,
  hiddenRobotAdd: true,
  rule: {
    title: '知识文档',
    title1: '文档',
    title2: '通用问答包',
    noData: '文档',
    name: '文档',
  },
  unionId: 95
})



agentMap.set('aida.iedux.cn', {
  logo: '',
  headerLogo: require('./assets/agent/saier-logo.png'),
  name: '高校智能客服',
  loginMsg0: '知识是无价之宝，我们帮助您掌握他！',
  loginMsg1: '应用了人工智能的自然语言识别处理、大数据、云计算等技术，',
  loginMsg2: '为学校授课老师建立智能的知识收集、归类、自动解答平台',
  loginMsg3: '产品负责人： 周老师 18310505996（手机、微信）',
  title: '赛尔超星 高校智能客服',
  homePage: 'http://aida.iedux.cn/',
  canRegister: false,
  callUs: {
    pic: require('./assets/agent/Wechat.jpeg'),
    code0: '微信扫码关注高校智能客服周老师',
    code1: '功能使用与技能支持: 18310505996',
    email: 'zhour@cernet.com',
  },
  email: 'zhour@cernet.com',
  phone: '18310505996',
  businessDialogMsg: '了解更多功能细节或购买高校智能客服，请您联系：：',
  nav2Name: '助教老师',
  menu: {
    kbStatistics: '机器人问答统计',
    evaluation: '人工客服问答统计'
  },
  taskName: '第三方应用对接',
  hiddenAccountInfo: true,
  hiddenRobotAdd: true,
  rule: {
    title: '知识文档',
    title1: '文档',
    title2: '通用问答包',
    noData: '文档',
    name: '文档',
  },
  userManager: {
    tenantUserName: '助教老师'
  },
  unionId: 109
})

agentMap.set('aida.zhoulaoshi.net', {
  // agentMap.set('localhost:8081', {
  logo: '',
  headerLogo: require('./assets/agent/saier-logo.png'),
  name: '高校智能客服',
  loginMsg0: '帮您自动准确解答95%的问题，剩下5%疑问人工回答！',
  loginMsg1: '应用了人工智能的自然语言识别处理、大数据、云计算等技术，',
  loginMsg2: '为学校业务部门建立统一管理的在线智能咨询服务平台',
  loginMsg3: '产品负责人： 周老师 18310505996（手机、微信）',
  title: '高校智能客服',
  homePage: 'http://aida.zhoulaoshi.net/',
  canRegister: false,
  callUs: {
    pic: require('./assets/agent/Wechat.jpeg'),
    code0: '微信扫码关注高校智能客服周老师',
    code1: '功能使用与技能支持: 18310505996',
    email: 'zhour@cernet.com',
  },
  email: 'zhour@cernet.com',
  phone: '18310505996',
  businessDialogMsg: '了解更多功能细节或购买高校智能客服，请您联系：',
  nav2Name: '助教老师',
  menu: {
    kbStatistics: '机器人问答统计',
    evaluation: '人工客服问答统计'
  },
  taskName: '第三方应用对接',
  hiddenAccountInfo: true,
  hiddenRobotAdd: true,
  rule: {
    title: '知识库',
    noData: '知识问答',
    name: '知识点',
  },
  userManager: {
    tenantUserName: '助教老师'
  },
  unionId: 109
})


// 引入lodash

window._ = require('lodash')

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

const i18n = new VueI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': require('./common/lang/zh'),
    'en-US': require('./common/lang/en')
  }
})
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>',
  created() {
    // 设置语言
    if (localStorage.getItem('accept-language')) {
      i18n.locale = localStorage.getItem('accept-language');
    } else {
      let lang = navigator.language || navigator.userLanguage;
      lang = lang.substr(0, 2);
      if (lang == 'zh') {
        i18n.locale == 'zh-CN'
      } else {
        i18n.locale == 'en-US'
      }
      localStorage.setItem('accept-language', i18n.locale);
    };
    let agentMap = new Map();
    agentMap.set('kefu.xiaolaba.xin', {
      // agentMap.set('localhost:8080', {
      logo: '',
      headerLogo: require('./assets/agent/saier-logo.png'),
      name: this.$t(`m.高校智能客服`),
      loginMsg0: this.$t(`m['帮您自动准确解答95%的问题，剩下5%疑问人工回答！']`),
      loginMsg1: this.$t(`m['应用了人工智能的自然语言识别处理、大数据、云计算等技术，']`),
      loginMsg2: this.$t(`m['为学校业务部门建立统一管理的在线智能咨询服务平台']`),
      loginMsg3: this.$t(`m['产品负责人： 周老师 18310505996（手机、微信）']`),
      title: this.$t(`m['赛尔超星 高校智能客服']`),
      homePage: 'http://www.xiaolaba.xin/',
      canRegister: false,
      callUs: {
        pic: require('./assets/agent/Wechat.jpeg'),
        code0: this.$t(`m.微信扫码关注高校智能客服周老师`),
        code1: this.$t(`m.功能使用与技能支持`) + ': 18310505996',
        email: 'zhour@cernet.com',
      },
      email: 'zhour@cernet.com',
      phone: '18310505996',
      businessDialogMsg: this.$t(`m['了解更多功能细节或购买高校智能客服产品，请您联系']`) + '：',
      nav2Name: this.$t(`m.人工客服`),
      menu: {
        kbStatistics: this.$t(`m.机器人问答统计`),
        evaluation: this.$t(`m.人工客服问答统计`)
      },
      taskName: this.$t(`m.第三方应用对接`),
      hiddenAccountInfo: true,
      hiddenRobotAdd: true,
      unionId: 95
    })

    agentMap.set('kefu.ceredu.org', {
      // agentMap.set('localhost:8080', {
      logo: '',
      headerLogo: require('./assets/agent/saier-logo.png'),
      name: this.$t(`m.高校智能客服`),
      loginMsg0: this.$t(`m['帮您自动准确解答95%的问题，剩下5%疑问人工回答！']`),
      loginMsg1: this.$t(`m['应用了人工智能的自然语言识别处理、大数据、云计算等技术，']`),
      loginMsg2: this.$t(`m['为学校业务部门建立统一管理的在线智能咨询服务平台']`),
      loginMsg3: this.$t(`m['产品负责人： 周老师 18310505996（手机、微信）']`),
      title: this.$t(`m['赛尔超星 高校智能客服']`),
      homePage: 'http://kefu.ceredu.org/',
      canRegister: false,
      callUs: {
        pic: require('./assets/agent/Wechat.jpeg'),
        code0: this.$t(`m.微信扫码关注高校智能客服周老师`),
        code1: this.$t(`m.功能使用与技能支持`) + ': 18310505996',
        email: 'zhour@cernet.com',
      },
      email: 'zhour@cernet.com',
      phone: '18310505996',
      businessDialogMsg: this.$t(`m['了解更多功能细节或购买高校智能客服产品，请您联系']`) + '：',
      nav2Name: this.$t(`m.人工客服`),
      menu: {
        kbStatistics: this.$t(`m.机器人问答统计`),
        evaluation: this.$t(`m.人工客服问答统计`)
      },
      taskName: this.$t(`m.第三方应用对接`),
      hiddenAccountInfo: true,
      hiddenRobotAdd: true,
      unionId: 95
    })


    agentMap.set('aida.iedux.cn', {
      logo: '',
      headerLogo: require('./assets/agent/saier-logo.png'),
      name: '高校智能客服',
      loginMsg0: this.$t(`m['帮您自动准确解答95%的问题，剩下5%疑问人工回答！']`),
      loginMsg1: this.$t(`m['应用了人工智能的自然语言识别处理、大数据、云计算等技术，']`),
      loginMsg2: this.$t(`m.为学校业务部门建立统一管理的在线智能咨询服务平台`),
      loginMsg3: this.$t(`m['产品负责人： 周老师 18310505996（手机、微信）']`),
      title: '高校智能客服',
      homePage: 'http://aida.iedux.cn/',
      canRegister: false,
      callUs: {
        pic: require('./assets/agent/Wechat.jpeg'),
        code0: '微信扫码关注高校智能客服周老师',
        code1: '功能使用与技能支持: 18310505996',
        email: 'zhour@cernet.com',
      },
      email: 'zhour@cernet.com',
      phone: '18310505996',
      businessDialogMsg: '了解更多功能细节或购买高校智能客服，请您联系：',
      nav2Name: this.$t(`m.助教老师`),
      menu: {
        kbStatistics: this.$t(`m.机器人问答统计`),
        evaluation: this.$t(`m.人工客服问答统计`)
      },
      taskName: this.$t(`m.第三方应用对接`),
      hiddenAccountInfo: true,
      hiddenRobotAdd: true,
      rule: {
        title: this.$t(`m.知识库`),
        noData: this.$t(`m.知识问答`),
        name: this.$t(`m.知识点`),
      },
      userManager: {
        tenantUserName: this.$t(`m.助教老师`)
      },
      unionId: 109
    })

    agentMap.set('aida.zhoulaoshi.net', {
      // agentMap.set('localhost:8081', {
      logo: '',
      headerLogo: require('./assets/agent/saier-logo.png'),
      name: '高校智能客服',
      loginMsg0: this.$t(`m['帮您自动准确解答95%的问题，剩下5%疑问人工回答！']`),
      loginMsg1: this.$t(`m['应用了人工智能的自然语言识别处理、大数据、云计算等技术，']`),
      loginMsg2: this.$t(`m.为学校业务部门建立统一管理的在线智能咨询服务平台`),
      loginMsg3: this.$t(`m['产品负责人： 周老师 18310505996（手机、微信）']`),
      title: '高校智能客服',
      homePage: 'http://aida.zhoulaoshi.net/',
      canRegister: false,
      callUs: {
        pic: require('./assets/agent/Wechat.jpeg'),
        code0: '微信扫码关注高校智能客服周老师',
        code1: '功能使用与技能支持: 18310505996',
        email: 'zhour@cernet.com',
      },
      email: 'zhour@cernet.com',
      phone: '18310505996',
      businessDialogMsg: '了解更多功能细节或购买高校智能客服，请您联系：',
      nav2Name: this.$t(`m.助教老师`),
      menu: {
        kbStatistics: this.$t(`m.机器人问答统计`),
        evaluation: this.$t(`m.人工客服问答统计`)
      },
      taskName: this.$t(`m.第三方应用对接`),
      hiddenAccountInfo: true,
      hiddenRobotAdd: true,
      rule: {
        title: this.$t(`m.知识库`),
        noData: this.$t(`m.知识问答`),
        name: this.$t(`m.知识点`),
      },
      userManager: {
        tenantUserName: this.$t(`m.助教老师`)
      },
      unionId: 109
    })
    Vue.prototype.$agentMap = agentMap



    this.$httpService.initVue(this)
    Vue.prototype.$this = this
    router.beforeEach((to, from, next) => {
      // 脏值检测
      let name = from.name || ''
      if (this.$httpService.checkRouterName.indexOf(name) > -1 && this.$pageDerty && from.query.type != 'MENU') {
        this.$confirm(this.$t(`m['该页面存在未保存的修改, 是否坚持离开']`) + "?", this.$t('m.common.prompt'), {
          confirmButtonText: this.$t('m.common.sure'),
          cancelButtonText: this.$t('m.common.cancle'),
          type: 'warning'
        }).then(() => {
          this.$httpService.pageClear()
          next()
        })
      } else {
        this.$httpService.pageClear()
        next()
      }
    })
  }
})


// import {s2ab} from '../services/sharedService'
Vue.prototype.$s2ab = function s2ab(s) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff
  }
  return buf
}



// WEBPACK FOOTER //
// ./src/main.js